import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, CircularProgress } from "@mui/material";
import FitroUserApps from "./components/FitroUserApps";
import { getFiltrarLocales, getFiltrarUsuariosLocales } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import UsuariosTableComponent from "./components/UsuariosTableComponent";

function UsuariosLocalesAdminPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loadingCargarLocales, setLoadingCargarLocales] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataLocales, setDataLocales] = useState([]);
    const [localSearch, setLocalSearch] = useState("");
    const [localAutocompleteSearch, setLocalAutocompleteSearch] = useState("");
    const [localSelected, setLocalSelected] = useState(null);
    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);

    const stateToken = useSelector((state) => state.reducerGlobal.token);
    const history = useNavigate();

    const getLocalLabel = (local) => local?.nombre_fantasia || local?.nombre || "";

    useEffect(() => {
        if (!stateToken?.access_token) {
            return;
        }

        const timeOutId = setTimeout(() => {
            handleListarLocales(localAutocompleteSearch);
        }, 500);

        return () => clearTimeout(timeOutId);
    }, [stateToken, localAutocompleteSearch]);

    useEffect(() => {
        if (!stateToken?.access_token) {
            return;
        }

        const timeOutId = setTimeout(() => {
            handleApiFiltrarUsuariosLocales(1);
        }, 500);

        return () => clearTimeout(timeOutId);
    }, [stateToken, localSearch, localSelected, perPage]);

    const handleListarLocales = (nombre = "") => {
        const body = {
            page: 1,
            per_page: 15,
            estado: "todos",
            nombre,
            categoriaId: ""
        };

        setLoadingCargarLocales(true);

        getFiltrarLocales(stateToken?.access_token, body)
            .then((response) => {
                setDataLocales(response?.data || []);
                setLoadingCargarLocales(false);
            })
            .catch((error) => {
                console.log("error==>getFiltrarLocales", error);
                setDataLocales([]);
                setLoadingCargarLocales(false);
            });
    };

    const handleApiFiltrarUsuariosLocales = (page = 1) => {
        const body = {
            page,
            per_page: perPage,
            local_id: localSelected?.id || "",
            local: localSelected?.id ? "" : localSearch?.trim() || ""
        };

        setLoadingCargar(true);

        getFiltrarUsuariosLocales(stateToken?.access_token, body)
            .then((response) => {
                console.log("response==>getFiltrarUsuariosLocales", response?.data);
                setLoadingCargar(false);

                if (response?.data?.data?.length > 0) {
                    setDataUsuarios(response?.data?.data);
                } else {
                    setDataUsuarios([]);
                }

                setLoading(true);
                setMetaPaginacion({
                    current_page: response?.data?.current_page,
                    per_page: response?.data?.per_page,
                    total: response?.data?.total,
                    last_page: response?.data?.last_page
                });
            })
            .catch((error) => {
                console.log("error==>getFiltrarUsuariosLocales", error);
                setDataUsuarios([]);
                setLoading(true);
                setLoadingCargar(false);
            });
    };

    const handleSearchLocal = (value) => {
        setLocalSearch(value);
    };

    const handleAutocompleteSearchLocal = (value) => {
        setLocalAutocompleteSearch(value);

        if (!value || value !== getLocalLabel(localSelected)) {
            setLocalSelected(null);
        }
    };

    const handleLocalSelected = (value) => {
        setLocalSelected(value);
        setLocalAutocompleteSearch(value ? getLocalLabel(value) : "");
    };

    const handleEditClick = (item) => {
        console.log("Edit", item);
        history("/app/admin/usuarios-app/editar/" + item?.id);
    };

    const handleDetalleClick = (item) => {
        console.log("Detalle", item);
        history("/app/admin/usuarios-app/detalle/" + item?.id);
    };

    const handleResetPassword = (item) => {
        console.log("Reset Password", item);
        history('/app/admin/usuarios-app/detalle-reset/' + item?.id);
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <FitroUserApps
                            dataLocales={dataLocales}
                            loadingCargarLocales={loadingCargarLocales}
                            localSelected={localSelected}
                            localSearch={localSearch}
                            localAutocompleteSearch={localAutocompleteSearch}
                            handleSearchLocal={handleSearchLocal}
                            handleAutocompleteSearchLocal={handleAutocompleteSearchLocal}
                            handleLocalSelected={handleLocalSelected}
                        />

                        <div>
                            <UsuariosTableComponent
                                data={dataUsuarios}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarUsuariosLocales}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                                handleDetalleItem={handleDetalleClick}
                                handleResetPassword={handleResetPassword}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default UsuariosLocalesAdminPage;